import { API } from "../../../backend";
import { objectToQueryString } from "../../../lib/utils";

export const getBranchConfig = (userId, token, branchId) => {
  return fetch(`${API}/branch/config/${userId}/${branchId}`, {
    method: 'GET',
    headers: {
      Accept: "application/json",
      'Content-type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  }).then(res => res.json()).catch(console.error)
}
